import { Inject, Injectable } from '@angular/core';
import { smartFooterInterface } from '../models/smart-footer.interface';
import { COPYRIGHT, LOGO_ALT, LOGO_HEIGHT, LOGO_MIME, LOGO_URL, LOGO_WIDTH } from '../constants/smart-footer.constants';
import { LIB_CONFIG } from '../lib-config';
import { LibConfig } from '../models/lib-config.model';

@Injectable({
  providedIn: 'root',
})
export class SmartFooterUtilityService {
  constructor(@Inject(LIB_CONFIG) private config: LibConfig) {}

  formatToSmartFooterObj(obj: any) {
    const strapiUrl = this.config.assetsPath;
    const smartFooter: smartFooterInterface = {
      links: obj?.link,
      logo: {
        alt: LOGO_ALT,
        default: {
          url: strapiUrl + 'logos/white@3x.png', // strapiUrl + obj?.logo?.media?.[0]?.url,
          width: LOGO_WIDTH,
          height: LOGO_HEIGHT,
          mime: LOGO_MIME,
        },
        images: [],
      },
      copyright: COPYRIGHT,
      logoURL: LOGO_URL,
    };
    return smartFooter;
  }
}
